import { render, staticRenderFns } from "./FulfillmentIcon.vue?vue&type=template&id=b251eafc"
import script from "./FulfillmentIcon.vue?vue&type=script&lang=js"
export * from "./FulfillmentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports